import L, { Marker as LeafletMarker } from 'leaflet';
import React from 'react';
import { LeafletProvider, MapLayer, withLeaflet } from 'react-leaflet';
// _initIcon, _setPos и _icon — приватное API Leaflet, в @types/leaflet их нет.
const markerProto = LeafletMarker.prototype;
let proto_initIcon = markerProto._initIcon;
let proto_setPos = markerProto._setPos;
let oldIE = L.DomUtil.TRANSFORM === 'msTransform';
LeafletMarker.addInitHook(function () {
    let iconOptions = this.options.icon && this.options.icon.options;
    let iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
    if (iconAnchor) {
        iconAnchor = iconAnchor[0] + 'px ' + iconAnchor[1] + 'px';
    }
    this.options.rotationOrigin = this.options.rotationOrigin || iconAnchor || 'center bottom';
    this.options.rotationAngle = this.options.rotationAngle || 0;
    // Ensure marker keeps rotated during dragging
    this.on('drag', function (e) {
        e.target._applyRotation();
    });
});
LeafletMarker.include({
    _initIcon: function () {
        proto_initIcon.call(this);
    },
    _setPos: function (pos) {
        proto_setPos.call(this, pos);
        this._applyRotation();
    },
    _applyRotation: function () {
        if (this.options.rotationAngle) {
            this._icon.style[L.DomUtil.TRANSFORM + 'Origin'] = this.options.rotationOrigin;
            if (oldIE) {
                // for IE 9, use the 2D rotation
                this._icon.style[L.DomUtil.TRANSFORM] = 'rotate(' + this.options.rotationAngle + 'deg)';
            }
            else {
                // for modern browsers, prefer the 3D accelerated version
                this._icon.style[L.DomUtil.TRANSFORM] += ' rotateZ(' + this.options.rotationAngle + 'deg)';
            }
        }
    },
    setRotationAngle: function (angle) {
        this.options.rotationAngle = angle;
        this.update();
        return this;
    },
    setRotationOrigin: function (origin) {
        this.options.rotationOrigin = origin;
        this.update();
        return this;
    },
});
class RotatedMarker extends MapLayer {
    createLeafletElement(props) {
        const el = new LeafletMarker(props.position, this.getOptions(props));
        this.contextValue = Object.assign(Object.assign({}, props.leaflet), { popupContainer: el });
        return el;
    }
    updateLeafletElement(fromProps, toProps) {
        if (toProps.position !== fromProps.position) {
            this.leafletElement.setLatLng(toProps.position);
        }
        if (toProps.icon !== fromProps.icon) {
            this.leafletElement.setIcon(toProps.icon);
        }
        if (toProps.zIndexOffset !== fromProps.zIndexOffset) {
            this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
        }
        if (toProps.opacity !== fromProps.opacity) {
            this.leafletElement.setOpacity(toProps.opacity);
        }
        if (toProps.draggable !== fromProps.draggable) {
            if (toProps.draggable === true) {
                this.leafletElement.dragging.enable();
            }
            else {
                this.leafletElement.dragging.disable();
            }
        }
        if (toProps.rotationAngle !== fromProps.rotationAngle) {
            this.leafletElement.setRotationAngle(toProps.rotationAngle);
        }
        if (toProps.rotationOrigin !== fromProps.rotationOrigin) {
            this.leafletElement.setRotationOrigin(toProps.rotationOrigin);
        }
    }
    render() {
        const { children } = this.props;
        return children == null || this.contextValue == null ? null : React.createElement(LeafletProvider, { value: this.contextValue }, children);
    }
}
RotatedMarker.defaultProps = {
    rotationOrigin: 'center',
};
export default withLeaflet(RotatedMarker);
